import React from 'react'

export default function ApprovalConsent({ showConsent, consent, onConsentChange, t }) {
  if (!showConsent) return null

  return (
    <div className="approve-consent">
      <div className="approve-consent-label">{t('approve.consentLabel')}</div>
      <button
        className={`approve-consent-checkbox ${consent ? 'approve-consent-checkbox--checked' : ''}`}
        onClick={e => e.preventDefault() & onConsentChange(consent === false)}>
        <div className="approve-consent-checkbox-icon-wrapper">
          <span className="approve-consent-checkbox-icon">{consent ? <i className="fa fa-check" /> : null}</span>
        </div>
        <div className="approve-consent-checkbox-text">{t('approve.consentQuestion')}</div>
      </button>
    </div>
  )
}
